import { countriesAlpha2 } from '@sequencehq/api/utils/commonEnums'

export const countriesOptions = Object.entries(countriesAlpha2).map(
  ([value, label]) => ({
    value,
    label
  })
)
